import { Expose, plainToInstance, Type } from "class-transformer";
import { Country } from "./country/country.model";

export class Theme {
    @Expose()
    @Type(() => ColorsTheme)
    colors: ColorsTheme;

    @Expose()
    @Type(() => PictureTheme)
    pictures: PictureTheme;

    @Expose()
    @Type(() => Array<Country>)
    countryList: Array<Country>;

    @Expose()
    @Type(() => CustomText)
    customText: CustomText;

    static from(payload: Record<string, any>): Theme {
        return plainToInstance(Theme, payload);
    }
}

export class ColorsTheme {
    @Expose()
    primary: string;

    @Expose()
    secondary: string;
}

export class PictureTheme {
    @Expose()
    logo: string;
}


export class CustomText {
    @Expose()
    titleLobby: string;

    @Expose()
    descriptionLobby: string;

    @Expose()
    titleWelcome: string;

    @Expose()
    descriptionWelcome: string;

    @Expose()
    conditionsUseWelcome: string;

    @Expose()
    titleFinish: string;

    @Expose()
    descriptionFinish: string;
}
